'use strict';
Object.defineProperty(exports, "__esModule", { value: true });
exports.YouTube = void 0;
const $ = require("jquery");
const YouTubeIframeLoader = require("youtube-iframe");
class YouTube {
    constructor() {
        // イベント
        setPlayer();
        // YouTube Playerのセット
        function setPlayer() {
            const youTubeId = 'EbECZJfz_BI';
            YouTubeIframeLoader.load(function (YT) {
                const player = new YT.Player('bulletTopPlayer', // 埋め込む場所の指定
                {
                    videoId: youTubeId,
                    playerVars: {
                        rel: 0,
                        loop: 1,
                        playlist: youTubeId,
                        controls: 0,
                        autoplay: 1,
                        showinfo: 0, //動画タイトルなど表示しない
                    },
                    events: {
                        'onReady': onPlayerReady,
                        'onStateChange': function (event) {
                            if (event.data === YT.PlayerState.PAUSED) {
                                event.target.playVideo();
                            }
                        }
                    }
                });
            });
        }
        //プレイ準備完了後
        function onPlayerReady(event) {
            event.target.mute();
            event.target.playVideo();
            event.target.setPlaybackQuality("hd1080");
            $('.bulletMainVisual').css('background-image', 'none');
        }
    }
}
exports.YouTube = YouTube;
exports.default = YouTube;
